import { useState, useEffect, useRef } from 'react'
import Breadcrumbs from './../../../components/Common/Breadcrumb'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import { addButtonSpinner, removeButtonSpinner, removeRightSectionSpinner, addRightSectionSpinner, updateUserData } from '../../../store/actions'
import { AGENT_USER_TYPE_ID, ERROR_KEY, MERCHANT_USER_TYPE_ID, SUCCESS_KEY, fieldLengths } from '../../../Constants/MainKeys'
import AlertService from '../../../Services/alertService'
import uuid from 'react-uuid'
import {
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  UncontrolledAlert,
} from "reactstrap"
import HtmlHead from '../../../components/HtmlHead/HtmlHead'
import RightSectionSpinner from '../../../components/Spinners/RightSectionSpinner'
import ActionButton from '../../../components/Buttons/ActionButton'
import ReactSelectOption from '../../../components/SelectOptions/ReactSelectOption'
import MainService from '../../../Services/MainService'
import ApiService from '../../../Services/ApiService'
import BankAccountInput from '../../../components/Inputs/BankAccountInput'

const buttonSpinnerId = uuid();
const BankAccountForm = (props) => {

  const query = new URLSearchParams(props.location.search);
  const redirectUrl = query.get('redirectUrl');

  const { accountId } = props.match.params;
  const title = "Bank Account form"
  const description = "";
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.Login);
  const { rightSectionSpinners } = useSelector(state => state.Spinners);
  const { language } = useSelector(state => state.Languages);
  const { countries, accountTypes, routingTypes } = useSelector(state => state.Main);
  const [isInvalidSubmit, setIsInvalidSubmit] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [_routingTypes, _setRoutingTypes] = useState([]);

  const [payoutMethods, setPayoutMethods] = useState([]);
  const [holderTypes, setHolderTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(false);

  const [values, setValues] = useState({
    // -------------------------------------------------------------------
    accountNumber: "",
    accountName: "",
    bankName: "",
    bankAddress: "",
    bankCode: "",
    branchCode: "",
    swiftCode: "",
    province: "",
    city: "",
    countryId: null,
    holderTypeLibraryDataId: null,
    currencyId: null,
    paymentMethodLibraryDataId: null,
    routingTypeLibraryDataId: null, // dropdown

    // added 24.10.2025
    iBan: "",
    accountType: "", // dropdown
    routingValue: "", //routing_value1 this field available only for US and USD
    // 
    // added 14.11.2025
    routingTypeName: "",
    // -------------------------------------------------------------------
  })

  // for Pyvio
  const fieldMap = {
    accountName: "account_name",
    accountNumber: "account_no",
    bankName: "bank_name",
    bankCode: "bank_code",
    branchCode: "branch_code",
    bankAddress: "bank_address",
    swiftCode: "swift_code",
    province: "province",
    city: "city",
    iBan: "iban",
    routingValue: "routing_value1",
    routingTypeLibraryDataId: "routing_type1",
  };

  useEffect(() => {
    if (routingTypes && routingTypes.libraryData && routingTypes.libraryData.length && values.routingTypeName) {
      setValues(prev => ({
        ...prev,
        routingTypeLibraryDataId: routingTypes.libraryData.find(el => el.displayName === values.routingTypeName)?.id || 0,
      }));
    }
  }, [routingTypes, values.routingTypeName])

  useEffect(() => {
    getAccount();
  }, [accountId])

  useEffect(() => {
    getBankList();
  }, [values.countryId, values.currencyId, currencies, countries])

  useEffect(() => {
    if (selectedBankAccount && Object.keys(selectedBankAccount).length) {
      const { country, label, currency, value, ...rest } = selectedBankAccount;
      setValues(prev => ({
        ...prev,
        ...rest,
      }));
    }
  }, [selectedBankAccount]);

  useEffect(() => {
    let isMounted = true;

    if (!banks?.length) {
      if (isMounted) setSelectedBankAccount(null);
      return;
    }

    const foundBank =
      banks.find((el) => el.bankName === values?.bankName) || null;

    if (isMounted) setSelectedBankAccount(foundBank);

    return () => {
      isMounted = false; // cleanup при размонтировании
    };
  }, [values?.bankName, banks]);

  const getBankList = () => {
    if (!values.countryId || !values.currencyId || !countries.length || !currencies.length) {
      setBanks([]);
      return false;
    }
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    const data = {
      country: countries.find(el => el.id === values.countryId)?.isoCode2,
      currency: currencies.find(el => el.id === values.currencyId)?.name,
      page_no: "0",
      page_size: "500"
    }
    ApiService.getBankList(data).then(response => {
      if (response && response.data && response.data.list) {
        setBanks(response.data.list);
      } else {
        setBanks([]);
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    })
  }

















  const [validationData, setValidationData] = useState(null);

  useEffect(() => {
    if (holderTypes.length && countries.length && currencies.length && payoutMethods.length) {
      getPayeeTemplate();
    }
  }, [
    values.holderTypeLibraryDataId,
    values.currencyId,
    values.countryId,
    values.paymentMethodLibraryDataId,
    values.routingTypeLibraryDataId,
    holderTypes,
    countries,
    currencies,
    payoutMethods
  ])

  useEffect(() => {
    getRoutingTypes();
  }, [
    values.countryId,
    values.currencyId,
    values.paymentMethodLibraryDataId,
    values.holderTypeLibraryDataId,
    holderTypes,
    countries,
    currencies,
    payoutMethods
  ])

  const getRoutingTypes = () => {
    if (
      !holderTypes.length ||
      !countries.length ||
      !currencies.length ||
      !payoutMethods.length ||
      !values.countryId ||
      !values.currencyId ||
      !values.paymentMethodLibraryDataId ||
      !values.holderTypeLibraryDataId
    ) {
      _setRoutingTypes([]);
      setValues((values) => ({
        ...values,
        routingTypeName: null,
      }));
      return false;
    }
    // const data = {
    //   country: "",
    //   currency: "",
    //   paymentMethod: "",
    //   holderType: "",
    // }
    if (!values.countryId || !values.currencyId || !values.paymentMethodLibraryDataId || !values.holderTypeLibraryDataId) { return false; }
    const data = {};
    if (holderTypes.length && values.holderTypeLibraryDataId) {
      data.holderType = holderTypes.find(el => el.id === values.holderTypeLibraryDataId)?.displayName;
    }
    if (countries.length && values.countryId) {
      data.country = countries.find(el => el.id === values.countryId)?.isoCode2;
    }
    if (currencies.length && values.currencyId) {
      data.currency = currencies.find(el => el.id === values.currencyId)?.name;
    }
    if (payoutMethods && payoutMethods.length) {
      data.paymentMethod = payoutMethods.find(el => el.id === values.paymentMethodLibraryDataId)?.displayName;
    }
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getRoutingTypes(data).then(response => {
      if (response && response.data && response.data.length) {
        _setRoutingTypes(response.data)
      } else {
        _setRoutingTypes([])
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    })
  }

  const getPayeeTemplate = () => {

    // const data = {
    //   payeeType: "Payee",
    //   holderType: "Company",
    //   country: "HK",
    //   currency: "USD",
    //   paymentMethod: "Swift",
    //   routingType: "Swift"
    // }
    const data = {
      payeeType: "Payee",
    }
    if (holderTypes.length && values.holderTypeLibraryDataId) {
      data.holderType = holderTypes.find(el => el.id === values.holderTypeLibraryDataId)?.displayName;
    }
    if (countries.length && values.countryId) {
      data.country = countries.find(el => el.id === values.countryId)?.isoCode2;
    }
    if (currencies.length && values.currencyId) {
      data.currency = currencies.find(el => el.id === values.currencyId)?.name;
    }
    if (payoutMethods && payoutMethods.length) {
      data.paymentMethod = payoutMethods.find(el => el.id === values.paymentMethodLibraryDataId)?.displayName;
    }
    if (values.routingTypeName) {
      // data.routingType = _routingTypes.libraryData.find(el => el.id === values.routingTypeLibraryDataId)?.displayName;
      data.routingType = values.routingTypeName;
    }

    // const spinnerId = uuid();
    // setRightSectionSpinner(spinnerId);
    ApiService.getPayeeTemplate(data).then(response => {
      if (response && response.data && response.data.data) {
        const backendData = JSON.parse(response.data.data);
        if (backendData && backendData.data && backendData.data.length) {
          const validationSchema = {
            ...backendData.data[0]?.bank_account_info,
            // ...backendData.data[0]?.payee_info
          };

          // todo
          if (validationSchema && validationSchema.province) {
            validationSchema.province.type = "text";
          }
          // 

          setValidationData(validationSchema);
        } else {
          setValidationData(null);
        }
      } else {
        setValidationData(null);
      }
    }).catch(error => getFail(error)).finally(() => {
      // extractRightSectionSpinner(spinnerId);
    })
  }

  const isInvalid = (fieldName) => {
    if (!validationData || !fieldMap[fieldName]) return false;
    const backendKey = fieldMap[fieldName];
    const schema = validationData;
    const rule = schema[backendKey];
    if (!rule) return false;
    const value = values[fieldName] || "";
    if (rule.required && !value.trim()) return true;

    if (rule.type === "OPTION") {
      rule.pattern = "^[0-9]+$";
    }
    if (rule.pattern && value) {
      try {
        return !new RegExp(rule.pattern).test(value);
      } catch (e) {
        console.warn("Invalid regex pattern:", rule.pattern);
        return false;
      }
    }

    return false;
  };

  const isFormValid = () => {
    if (!validationData) return true;
    return Object.keys(fieldMap).every(fieldName => !isInvalid(fieldName));
  };











  useEffect(() => {
    if (values.countryId) {
      getPaymentMethodsByCountryId(values.countryId);
    }
  }, [values.countryId])

  const getPaymentMethodsByCountryId = (countryId) => {
    if (!countryId) { return false; }
    ApiService.getPaymentMethodsByCountryId(countryId).then(response => {
      if (response && response.data) {
        setPayoutMethods(response.data)
      } else {
        setPayoutMethods([]);
      }
    }).catch(error => getFail(error)).finally(() => { })
  }

  const getHolderTypesByCountry = (countryId, paymentMethodId) => {
    if (!countryId) { return false; }
    ApiService.getHolderTypesByCountry(countryId, paymentMethodId).then(response => {
      if (response && response.data) {
        setHolderTypes(response.data)
      } else {
        setHolderTypes([]);
      }
    }).catch(error => getFail(error)).finally(() => { })
  }

  useEffect(() => {
    if (values.countryId && values.paymentMethodLibraryDataId) {
      getHolderTypesByCountry(values.countryId, values.paymentMethodLibraryDataId);
      getFiatCurrencies(values.countryId, values.paymentMethodLibraryDataId);
    }
  }, [values.countryId, values.paymentMethodLibraryDataId])

  const getFiatCurrencies = (countryId, paymentMethodId) => {
    if (!countryId || !paymentMethodId) { return false; }
    ApiService.getFiatCurrenciesByCountryIdAndPaymentMethodId(countryId, paymentMethodId).then(response => {
      if (response && response.data) {
        setCurrencies(response.data);
      } else {
        setCurrencies([]);
      }
    }).catch(error => getFail(error)).finally(() => { })
  }

  const getAccount = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    (user.userTypeId === MERCHANT_USER_TYPE_ID ?
      ApiService.getAccountAsMerchant(accountId || null) :
      ApiService.getAccountAsAgent(accountId || null))
      .then(response => {
        if (response && response.data) {
          const data = { ...response.data };
          setValues(data);
        }
      }).catch(error => getFail(error)).finally(() => {
        setTimeout(() => {
          extractRightSectionSpinner(spinnerId);
        }, 1000);
      })
  }

  const getInvalidField = () => {
    if (payoutMethods && payoutMethods.length && !values.paymentMethodLibraryDataId) {
      return true;
    }
    if (holderTypes && holderTypes.length && !values.holderTypeLibraryDataId) {
      return true;
    }
    if (currencies && currencies.length && !values.currencyId) {
      return true;
    }
    if (checkAbaIsSisabled() === false && !values.routingValue) {
      return true;
    }

    if (banks && banks.length && banks.some(el => el.bankName === values.bankName)) {
      return false
    }
    if (
      !values.accountNumber ||
      !values.accountName ||
      !values.bankName ||
      (values.bankName && banks.length && !banks.some(el => el.bankName === values.bankName)) ||
      !values.bankAddress ||
      !values.bankCode ||
      // !values.swiftCode ||
      !values.branchCode ||
      !values.countryId ||
      !values.province ||
      !values.city ||
      (!values.routingTypeLibraryDataId && !values.routingTypeName) ||
      !values.accountType

    ) {
      return true;
    } else {
      return false;
    }
  }


  const onChange = (event, field, maxLength = null) => {
    if (maxLength && maxLength < event.target.value.length) { return; }
    setValues((values) => ({
      ...values,
      [field]: event.target.value,
    }));
    setIsInvalidSubmit(false);
  }

  const onSelectOptionChange = (value, field) => {

    if (value === values[field]) {
      return false;
    }
    if (field === "countryId") {
      setValues((values) => ({
        ...values,
        paymentMethodLibraryDataId: null,
        holderTypeLibraryDataId: null,
        currencyId: null,
        routingTypeLibraryDataId: null,
        routingTypeName: null,
      }));
      setPayoutMethods([]);
      setHolderTypes([]);
      setCurrencies([]);
    } else if (field === "paymentMethodLibraryDataId") {
      setValues((values) => ({
        ...values,
        holderTypeLibraryDataId: null,
        currencyId: null,
        routingTypeLibraryDataId: null,
        routingTypeName: null,
      }));
      setHolderTypes([]);
      setCurrencies([]);
    } else if (field === "holderTypeLibraryDataId") {
      setValues((values) => ({
        ...values,
        routingTypeLibraryDataId: null,
        routingTypeName: null,
      }));
    } else if (field === "currencyId") {
      setValues((values) => ({
        ...values,
        routingTypeLibraryDataId: null,
        routingTypeName: null,
      }));
    }
    setValues((values) => ({
      ...values,
      [field]: value,
    }));
    setIsChanged(true);
    setIsInvalidSubmit(false)
  }

  const scrollMaxDown = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  const onSubmit = (event) => {
    event && event.preventDefault();
    const valuesCopy = { ...values };

    if (validationData) {
      if (!isFormValid()) {
        return false;
      }
    } else {
      if (getInvalidField()) {
        setIsInvalidSubmit(true);
        return false;
      }
    }

    if (!valuesCopy.routingTypeName) {
      delete valuesCopy.routingTypeName;
    }

    const updateData = (cb) => {
      setButtonSpinner(buttonSpinnerId);
      (user.userTypeId === MERCHANT_USER_TYPE_ID ?
        accountId ? ApiService.updateOrganizationBankAccountAsMerchant(valuesCopy) : ApiService.createAccountAsMerchant(valuesCopy) :
        user.userTypeId === AGENT_USER_TYPE_ID ?
          accountId ? ApiService.updateOrganizationBankAccountAsAgent(valuesCopy) : ApiService.createAccountAsAgent(valuesCopy) : null
      ).then((response) => {
        if (response && response.success) {
          if (response.data) {
            if (redirectUrl) {
              props.history.push(`/${language}/${redirectUrl}`)
            } else {
              props.history.push(`/${language}/bank-account-form/${response.data.id}`)
            }
          }
          setTimeout(() => {
            scrollMaxDown();
          }, 500);
          cb && cb();
        }
        AlertService.alert(SUCCESS_KEY, `Your account has been successfully ${accountId ? "updated" : "created"}`)
      }).catch(error => getFail(error)).finally(() => {
        extractButtonSpinner(buttonSpinnerId)
      })
    }

    const changeUserIsActive = () => {
      let userCopy = { ...user };
      userCopy.isOrganizationActive = false;
      userCopy.isActive = false;
      dispatch(updateUserData(userCopy));
    }

    if (user.userTypeId === MERCHANT_USER_TYPE_ID) {
      if (user.isActive) {
        AlertService.alertConfirm(
          `Are you sure ?`,
          "If you proceed with these changes your account status will lose it's verified status and you will need to wait for admin approval",
          "Yes",
          "No"
        ).then(() => {
          updateData(changeUserIsActive);
        })
      } else {
        updateData(changeUserIsActive);
      }
    }
  }

  const checkAbaIsSisabled = () => {

    if (countries && countries.length && values.countryId && values.currencyId && currencies && currencies.length) {
      let country = countries.find(el => el.id === values.countryId && el.name === "United States");
      let currency = currencies.find(currency => currency.id === values.currencyId && currency.name === "USD");

      if (!country || !currency) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const setButtonSpinner = useCallback(spinner => {
    dispatch(addButtonSpinner(spinner));
  }, []);

  const extractButtonSpinner = useCallback(spinner => {
    dispatch(removeButtonSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  return (
    <>
      <section className='page-content position-relative min-h-100'>
        <HtmlHead title={title} description={description} />
        <RightSectionSpinner spinner={rightSectionSpinners} />
        <div className="container-fluid">
          {
            values && !values.isApproved ?
              <UncontrolledAlert color="danger" role="alert">
                <i className="mdi mdi-block-helper me-2"></i>
                Attention: You can't perform any payout process with an inactive bank account. Please wait for approval from Cryllex administration.
              </UncontrolledAlert>
              : null
          }
          {
            accountId ?
              <UncontrolledAlert color="warning" role="alert">
                <i className="mdi mdi-alert-outline me-2"></i>
                After updating your bank account, its status has become inactive until approved by a Cryllex administrator. Please note that you will be unable to perform any actions with an inactive bank account.
              </UncontrolledAlert>
              : null
          }
          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Bank account form"
            isShowGoBackButton={true}
            goBack={() => window.history.back()}
          />
          <form onSubmit={onSubmit} onChange={() => setIsChanged(true)}>

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <Row>
                      <Col sm={12}>
                        <Row>
                          <Col lg={12}>
                            <Row>
                              {
                                validationData && validationData.account_name ?
                                  <Col lg={4} md={6} className="mb-4">
                                    <BankAccountInput
                                      id="accountName"
                                      labelValue="Account Name"
                                      required={validationData.account_name?.required}
                                      type={validationData.account_name.type}
                                      value={values.accountName || ""}
                                      placeholder="e.g. Cryllex"
                                      pattern={validationData.account_name?.pattern}
                                      error={isInvalid("accountName")}
                                      errorMessage={validationData.account_name?.enMessage}
                                      onChange={event => onChange(event, "accountName", fieldLengths.length_120)}
                                    />
                                  </Col>
                                  :
                                  <Col lg={4} md={6} className="mb-4">
                                    <Label htmlFor='accountName' className='text-muted text-truncate mb-0'>Account Name*</Label>
                                    <Input
                                      id="accountName"
                                      type="text"
                                      placeholder='e.g. Cryllex'
                                      className={`${(isInvalidSubmit && !values.accountName?.trim().length) ? "error-border" : ""}`}
                                      value={values.accountName || ""}
                                      onChange={event => onChange(event, "accountName", fieldLengths.length_120)}
                                    />
                                  </Col>
                              }

                              <Col lg={12}>
                                <UncontrolledAlert color="warning" role="alert" className='mb-0'>
                                  <i className="mdi mdi-alert-outline me-2"></i>
                                  Attention: Your legal business name is linked to your bank account, and any changes made to
                                  the bank account name will automatically update your business name as well.
                                </UncontrolledAlert>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={12}><hr /></Col>
                          {
                            validationData && validationData.account_no ?
                              <Col lg={4} md={6} className="mb-4">
                                <BankAccountInput
                                  id="accountNumber"
                                  labelValue="Account Number"
                                  required={validationData.account_no?.required}
                                  type={validationData.account_no.type}
                                  value={values.accountNumber || ""}
                                  placeholder='e.g. 10987654321'
                                  pattern={validationData.account_no?.pattern}
                                  error={isInvalid("accountNumber")}
                                  errorMessage={validationData.account_no?.enMessage}
                                  onChange={event => onChange(event, "accountNumber", fieldLengths.length_120)}
                                />
                              </Col>
                              :
                              <Col lg={4} md={6} className="mb-4">
                                <Label htmlFor='accountNumber' className={`text-muted text-truncate mb-0`}>Account Number*</Label>
                                <Input
                                  id="accountNumber"
                                  type="text"
                                  placeholder='e.g. 10987654321'
                                  className={`${(isInvalidSubmit && !values.accountNumber?.trim().length) ? "error-border" : ""}`}
                                  value={values.accountNumber || ""}
                                  onChange={event => onChange(event, "accountNumber", fieldLengths.length_120)}
                                />
                              </Col>
                          }
                          {
                            validationData && validationData.swift_code ?
                              <Col lg={4} md={6} className="mb-4">
                                <BankAccountInput
                                  id="swiftCode"
                                  labelValue="SWIFT Code"
                                  required={validationData.swift_code?.required}
                                  type={validationData.swift_code.type}
                                  value={values.swiftCode || ""}
                                  disabled={selectedBankAccount}
                                  placeholder='e.g. AAAA-BB-CC-DDD (BOFAUS6NGFX)'
                                  pattern={validationData.account_no?.pattern}
                                  error={isInvalid("swiftCode")}
                                  errorMessage={validationData.swift_code?.enMessage}
                                  onChange={event => onChange(event, "swiftCode", fieldLengths.length_120)}
                                />
                              </Col>
                              :
                              <Col lg={4} md={6} className="mb-4">
                                <Label htmlFor='swiftCode' className='text-muted text-truncate mb-0'>SWIFT Code*</Label>
                                <Input
                                  id="swiftCode"
                                  type="text"
                                  disabled={selectedBankAccount}
                                  className={`${(isInvalidSubmit && !values.swiftCode?.trim().length) ? "error-border" : ""}`}
                                  placeholder='e.g. AAAA-BB-CC-DDD (BOFAUS6NGFX)'
                                  value={values.swiftCode || ""}
                                  onChange={event => onChange(event, "swiftCode", fieldLengths.length_120)}
                                />
                              </Col>
                          }
                          {
                            validationData && validationData.iban ?
                              <Col lg={4} md={6} className="mb-4">
                                <BankAccountInput
                                  id="iBan"
                                  labelValue="iBan"
                                  required={validationData.iban?.required}
                                  type={validationData.iban.type}
                                  value={values.iBan || ""}
                                  placeholder='e.g. DE89 3704 0044 0532 0130 00'
                                  pattern={validationData.iban?.pattern}
                                  error={isInvalid("iBan")}
                                  errorMessage={validationData.iban?.enMessage}
                                  onChange={event => onChange(event, "iBan", fieldLengths.length_120)}
                                />
                              </Col>
                              :
                              <Col lg={4} md={6} className="mb-4">
                                <Label htmlFor='iBan' className='text-muted text-truncate mb-0'>iBan</Label>
                                <Input
                                  id="iBan"
                                  type="text"
                                  placeholder='e.g. DE89 3704 0044 0532 0130 00'
                                  className={`form-control`}
                                  value={values.iBan || ""}
                                  onChange={event => onChange(event, "iBan", fieldLengths.length_120)}
                                />
                              </Col>
                          }
                        </Row>
                        <hr className='mt-0' />
                        <Row className='mt-3'>
                          <Col sm={12}>
                            <Row>
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='countryId' className='text-muted text-truncate mb-0'>Country*</Label>
                                <ReactSelectOption
                                  value={values.countryId}
                                  isSearchable={true}
                                  className={`${(isInvalidSubmit && !values.countryId) ? "error-border" : ""}`}
                                  selectedValue={(() => {
                                    const selectedValue = { ...countries.find(data => data.id === values.countryId) };
                                    if (Object.keys(selectedValue).length) {
                                      selectedValue.label = selectedValue.name;
                                      selectedValue.value = selectedValue.id;
                                      return selectedValue;
                                    } else {
                                      return { label: "Choose...", value: "" }
                                    }
                                  })()}
                                  items={countries.map(data => ({ label: data.name, value: data.id }))}
                                  onChange={(item) => onSelectOptionChange(item.value, "countryId")}
                                />
                              </Col>
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='paymentMethodLibraryDataId' className='text-muted text-truncate mb-0'>Payout method*</Label>
                                <ReactSelectOption
                                  value={values.paymentMethodLibraryDataId}
                                  isSearchable={true}
                                  className={`${(isInvalidSubmit && !values.paymentMethodLibraryDataId) ? "error-border" : ""}`}
                                  selectedValue={(() => {
                                    const selectedValue = { ...payoutMethods.find(data => data.id === values.paymentMethodLibraryDataId) };
                                    if (Object.keys(selectedValue).length) {
                                      selectedValue.label = selectedValue.displayName;
                                      selectedValue.value = selectedValue.id;
                                      return selectedValue;
                                    } else {
                                      return { label: "Choose...", value: "" }
                                    }
                                  })()}
                                  items={payoutMethods.map(data => ({ label: data.displayName, value: data.id }))}
                                  onChange={(item) => onSelectOptionChange(item.value, "paymentMethodLibraryDataId")}
                                />
                              </Col>
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='holderTypeLibraryDataId' className='text-muted text-truncate mb-0'>Holder type*</Label>
                                <ReactSelectOption
                                  value={values?.holderTypeLibraryDataId}
                                  isSearchable={true}
                                  className={`${(isInvalidSubmit && !values.holderTypeLibraryDataId) ? "error-border" : ""}`}
                                  selectedValue={(() => {
                                    const selectedValue = { ...holderTypes.find(item => item.id === values?.holderTypeLibraryDataId) };
                                    if (Object.keys(selectedValue).length) {
                                      selectedValue.label = selectedValue.displayName;
                                      selectedValue.value = selectedValue.id;
                                      return selectedValue;
                                    } else {
                                      return { label: "Choose...", value: "" }
                                    }
                                  })()}
                                  items={holderTypes.map(data => ({ label: data.displayName, value: data.id }))}
                                  onChange={(item) => onSelectOptionChange(item.value, "holderTypeLibraryDataId")}
                                />
                              </Col>
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='currencyId' className='text-muted text-truncate mb-0'>Currencies*</Label>
                                <ReactSelectOption
                                  value={values.currencyId}
                                  isSearchable={true}
                                  // menuPlacement="auto"
                                  className={`${(isInvalidSubmit && !values.currencyId) ? "error-border" : ""}`}
                                  selectedValue={(() => {
                                    const selectedValue = { ...currencies.find(data => data.id === values.currencyId) };
                                    if (Object.keys(selectedValue).length) {
                                      selectedValue.label = selectedValue.name;
                                      selectedValue.value = selectedValue.id;
                                      return selectedValue;
                                    } else {
                                      return { label: "Choose...", value: "" }
                                    }
                                  })()}
                                  items={currencies.map(data => ({ label: data.name, value: data.id }))}
                                  onChange={(item) => onSelectOptionChange(item.value, "currencyId")}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={3} md={6} className="mb-4">
                            <Label htmlFor='routingTypeLibraryDataId' className='text-muted text-truncate mb-0'>Routing Type*</Label>
                            <ReactSelectOption
                              value={values.routingTypeName}
                              isSearchable={true}
                              className={`${(isInvalidSubmit && (!values.routingTypeLibraryDataId && !values.routingTypeName)) ? "error-border" : ""}`}
                              selectedValue={(() => {
                                if (routingTypes?.libraryData.find(el => el.id === values.routingTypeLibraryDataId)) {
                                  const selectedValue = { ...(routingTypes?.libraryData || []).find(el => el.id === values.routingTypeLibraryDataId) };
                                  if (Object.keys(selectedValue).length) {
                                    selectedValue.label = selectedValue.displayName;
                                    selectedValue.value = selectedValue.id;
                                    return selectedValue;
                                  } else {
                                    return { label: "Choose...", value: "" }
                                  }
                                } else {
                                  const selectedValue = (_routingTypes || []).find(el => el === values.routingTypeName);
                                  if (selectedValue) {
                                    return { label: selectedValue, value: selectedValue }
                                  } else {
                                    return { label: "Choose...", value: "" }
                                  }
                                }
                              })()}
                              items={(_routingTypes || []).map(data => ({ label: data, value: data }))}
                              onChange={(item) => {
                                setIsChanged(true);
                                setValues((values) => ({
                                  ...values,
                                  routingTypeName: item.value,
                                }));
                              }}
                            />
                          </Col>
                          <Col lg={3} md={6} className="mb-4">
                            <Label htmlFor='accountType' className='text-muted text-truncate mb-0'>Account Type*</Label>
                            <ReactSelectOption
                              value={values.accountType}
                              isSearchable={true}
                              className={`${(isInvalidSubmit && !values.accountType) ? "error-border" : ""}`}
                              selectedValue={(() => {
                                const selectedValue = { ...(accountTypes?.libraryData || []).find(data => data.id === values.accountType) };
                                if (Object.keys(selectedValue).length) {
                                  selectedValue.label = selectedValue.displayName;
                                  selectedValue.value = selectedValue.id;
                                  return selectedValue;
                                } else {
                                  return { label: "Choose...", value: "" }
                                }
                              })()}
                              items={(accountTypes?.libraryData || []).map(data => ({ label: data.displayName, value: data.id }))}
                              onChange={(item) => onSelectOptionChange(item.value, "accountType")}
                            />
                          </Col>
                          {
                            validationData && validationData.routing_value1 ?
                              <Col lg={3} md={6} className="mb-4">
                                <BankAccountInput
                                  id="routingValue"
                                  labelValue="ABA Routing Number"
                                  required={validationData.routing_value1?.required}
                                  type={validationData.routing_value1?.type}
                                  value={values.routingValue || ""}
                                  placeholder="e.g. 123456789"
                                  pattern={validationData.routing_value1?.pattern}
                                  error={isInvalid("routingValue")}
                                  errorMessage={validationData.routing_value1?.enMessage}
                                  onChange={event => onChange(event, "routingValue", fieldLengths.length_9)}
                                />
                                <small><i>This field available only for US and USD</i></small>
                              </Col>
                              :
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor="routingValue" className="text-muted text-truncate mb-0">
                                  ABA Routing Number{checkAbaIsSisabled() === false ? "*" : ""}
                                </Label>
                                <Input
                                  id="routingValue"
                                  type="number"
                                  disabled={checkAbaIsSisabled()}
                                  placeholder="e.g. 123456789"
                                  className={`${(isInvalidSubmit && checkAbaIsSisabled() === false && !values.routingValue?.trim().length) ? "error-border" : ""}`}
                                  value={values.routingValue || ""}
                                  onChange={event =>
                                    onChange(event, "routingValue", fieldLengths.length_9)
                                  }
                                />
                                <small><i>This field available only for US and USD</i></small>
                              </Col>
                          }
                        </Row>
                        <hr className='mt-0' />
                        <Row>

                          {
                            banks.length ?
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='bankName' className='text-muted text-truncate mb-0'>Select a Bank*</Label>
                                <ReactSelectOption
                                  value={values?.bankName}
                                  isSearchable={true}
                                  className={`${(isInvalidSubmit && (!values.bankName || (values.bankName && banks.length && !banks.some(el => el.bankName === values.bankName)))) ? "error-border" : ""}`}
                                  selectedValue={(() => {
                                    const selectedValue = { ...banks.find(item => item.bankName === values?.bankName) };
                                    if (Object.keys(selectedValue).length) {
                                      selectedValue.label = selectedValue.bankName;
                                      selectedValue.value = selectedValue.bankName;
                                      return selectedValue;
                                    } else {
                                      return { label: "Choose...", value: "" }
                                    }
                                  })()}
                                  items={banks.map(item => ({ label: item.bankName, ...item }))}
                                  onChange={(item) => {
                                    setValues((values) => ({
                                      ...values,
                                      bankName: item.bankName,
                                    }));
                                    setIsChanged(true);
                                  }}
                                />
                              </Col>
                              : validationData && validationData.bank_name ?
                                <Col lg={3} md={6} className="mb-4">
                                  <BankAccountInput
                                    id="bankName"
                                    labelValue="Bank Name"
                                    required={validationData.bank_name?.required}
                                    type={validationData.bank_name.type}
                                    value={values.bankName || ""}
                                    placeholder='e.g. Bank of America'
                                    pattern={validationData.bank_name?.pattern}
                                    error={isInvalid("bankName")}
                                    errorMessage={validationData.bank_name?.enMessage}
                                    onChange={event => onChange(event, "bankName", fieldLengths.length_120)}
                                  />
                                  {/* 龥 */}
                                </Col>
                                : <Col lg={3} md={6} className="mb-4">
                                  <Label htmlFor='bankName' className='text-muted text-truncate mb-0'>Bank Name*</Label>
                                  <Input
                                    id="bankName"
                                    type="text"
                                    placeholder='e.g. Bank of America'
                                    className={`${(isInvalidSubmit && !values.bankName?.trim().length) ? "error-border" : ""}`}
                                    value={values.bankName || ""}
                                    onChange={event => onChange(event, "bankName", fieldLengths.length_120)}
                                  />
                                </Col>
                          }
                          {
                            validationData && validationData.bank_address ?
                              <Col lg={3} md={6} className="mb-4">
                                <BankAccountInput
                                  id="bankAddress"
                                  labelValue="Bank Address"
                                  required={validationData.bank_address?.required}
                                  type={validationData.bank_address.type}
                                  value={values.bankAddress || ""}
                                  placeholder='e.g. Bank of America, N.A., 222 Broadway, New York, NY 10038, United States'
                                  pattern={validationData.bank_address?.pattern}
                                  error={isInvalid("bankAddress")}
                                  errorMessage={validationData.bank_address?.enMessage}
                                  onChange={event => onChange(event, "bankAddress", fieldLengths.length_120)}
                                />
                              </Col>
                              :
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='bankAddress' className='text-muted text-truncate mb-0'>Bank Address*</Label>
                                <Input
                                  id="bankAddress"
                                  type="text"
                                  placeholder='e.g. Bank of America, N.A., 222 Broadway, New York, NY 10038, United States'
                                  className={`${(isInvalidSubmit && !values.bankAddress?.trim().length) ? "error-border" : ""}`}
                                  value={values.bankAddress || ""}
                                  onChange={event => onChange(event, "bankAddress", fieldLengths.length_120)}
                                />
                              </Col>
                          }
                          {
                            validationData && validationData.bank_code ?
                              <Col lg={3} md={6} className="mb-4">
                                <BankAccountInput
                                  id="bankCode"
                                  labelValue="Bank Code"
                                  required={validationData.bank_code?.required}
                                  type={validationData.bank_code?.type}
                                  value={values.bankCode || ""}
                                  placeholder='e.g. 055'
                                  pattern={validationData.bank_code?.pattern}
                                  error={isInvalid("bankCode")}
                                  disabled={selectedBankAccount}
                                  errorMessage={validationData.bank_code?.enMessage}
                                  onChange={event => onChange(event, "bankCode", fieldLengths.length_120)}
                                />
                              </Col>
                              :
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='bankCode' className='text-muted text-truncate mb-0'>Bank Code*</Label>
                                <Input
                                  id="bankCode"
                                  type="text"
                                  disabled={selectedBankAccount}
                                  placeholder='e.g. 055'
                                  className={`${(isInvalidSubmit && !values.bankCode?.trim().length) ? "error-border" : ""}`}
                                  value={values.bankCode || ""}
                                  onChange={event => onChange(event, "bankCode", fieldLengths.length_120)}
                                />
                              </Col>
                          }
                          {
                            validationData && validationData.branch_code ?
                              <Col lg={3} md={6} className="mb-4">
                                <BankAccountInput
                                  id="branchCode"
                                  labelValue="Branch Code"
                                  required={validationData.branch_code?.required}
                                  type={validationData.branch_code?.type}
                                  value={values.branchCode || ""}
                                  placeholder='e.g. 055'
                                  pattern={validationData.branch_code?.pattern}
                                  error={isInvalid("branchCode")}
                                  errorMessage={validationData.branch_code?.type === "OPTION" ? "The Input Content must contain only numeric characters" : validationData.branch_code?.enMessage}
                                  onChange={event => onChange(event, "branchCode", fieldLengths.length_120)}
                                />
                              </Col>
                              :
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='branchCode' className='text-muted text-truncate mb-0'>Branch Code*</Label>
                                <Input
                                  id="branchCode"
                                  type="text"
                                  placeholder='e.g. 055'
                                  className={`${(isInvalidSubmit && !values.branchCode) ? "error-border" : ""}`}
                                  value={values.branchCode || ""}
                                  onChange={event => onChange(event, "branchCode")}
                                />
                              </Col>
                          }
                          {
                            validationData && validationData.province ?
                              <Col lg={3} md={6} className="mb-4">
                                <BankAccountInput
                                  id="province"
                                  labelValue="State/Province"
                                  required={validationData.province?.required}
                                  type={validationData.province?.type}
                                  value={values.province || ""}
                                  placeholder='e.g. California'
                                  pattern={validationData.province?.pattern}
                                  error={isInvalid("province")}
                                  errorMessage={validationData.province?.enMessage}
                                  onChange={event => onChange(event, "province", fieldLengths.length_120)}
                                />
                              </Col>
                              :
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='province' className='text-muted text-truncate mb-0'>State/Province*</Label>
                                <Input
                                  id="province"
                                  type="text"
                                  placeholder='e.g. California'
                                  className={`${(isInvalidSubmit && !values.province?.trim().length) ? "error-border" : ""}`}
                                  value={values.province || ""}
                                  onChange={event => onChange(event, "province", fieldLengths.length_120)}
                                />
                              </Col>
                          }
                          {
                            validationData && validationData.city ?
                              <Col lg={3} md={6} className="mb-4">
                                <BankAccountInput
                                  id="city"
                                  labelValue="City"
                                  required={validationData.city?.required}
                                  type={validationData.city?.type}
                                  value={values.city || ""}
                                  placeholder='e.g. California'
                                  pattern={validationData.city?.pattern}
                                  error={isInvalid("city")}
                                  errorMessage={validationData.city?.enMessage}
                                  onChange={event => onChange(event, "city", fieldLengths.length_120)}
                                />
                              </Col>
                              :
                              <Col lg={3} md={6} className="mb-4">
                                <Label htmlFor='city' className='text-muted text-truncate mb-0'>City*</Label>
                                <Input
                                  id="city"
                                  type="text"
                                  placeholder='e.g. Oakland'
                                  className={`${(isInvalidSubmit && !values.city?.trim().length) ? "error-border" : ""}`}
                                  value={values.city || ""}
                                  onChange={event => onChange(event, "city", fieldLengths.length_120)}
                                />
                              </Col>
                          }
                        </Row>
                      </Col>
                    </Row>
                    <div className='d-flex justify-content-end'>
                      <ActionButton
                        type="submit"
                        name="Submit"
                        className="btn btn-primary btn-block px-4"
                        spinnerId={buttonSpinnerId}
                        disabled={!isChanged || !isFormValid()}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </form>
        </div>
      </section>
    </>
  )
}

export default withRouter(BankAccountForm)